export enum TelecomType {
  PHONE = 'phone',
  LANDLINE = 'landlinePhone',
  APICRYPT = 'apicrypt',
  MSSANTE = 'mssante',
  EMAIL = 'email',
  LIFEN = 'lifen',
  ENS = 'ens',
}

export interface Telecom {
  id: string | undefined;
  value: string;
  type: TelecomType;
  valid?: boolean;
  displayName?: string;
  isContactPreference?: boolean;
  /** Known to the directory but no longer reachable: shown to the user, never sendable. */
  inactive?: boolean;
}

export type Telecoms = { [p in TelecomType]: Telecom[] };
